var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('figure',{attrs:{"id":"icone-cupom"}},[_c('img',{staticClass:"img-responsive",attrs:{"alt":"IconeCupom","src":require("@/assets/images/cupom.png")}})])
}]

export { render, staticRenderFns }